import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import {
  CreateIndentForm,
  IndentDepartmentList,
  IndentItemList,
} from "../../Repository/Api";
import { NonEmptyValidation, NumberValidation } from "../../Store/validate";
import { errorMsg, successMsg } from "../Toastify";

const IndentForm = () => {
  const { first_name, desingation, last_name, access_token } = useSelector(
    (state) => state?.auth?.auth
  );
  const token = access_token;

  const navigate = useNavigate();

  const [validation, setValidation] = useState({
    product_details: {},
  });
  const [departmentt, setDepartment] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [applyForm, setApplyForm] = useState({
    product_details: [
      {
        id: 0,
        product_id: "",
        quantity: "",
      },
    ],
  });

  useEffect(() => {
    getDepartment();
    getItemList();
  }, []);

  const getDepartment = async () => {
    const response = await IndentDepartmentList(token);
    if (response && response.statusCode === 200) {
      setDepartment(response?.data?.department);
    } else {
      errorMsg(response.message);
    }
  };

  const getItemList = async () => {
    const response = await IndentItemList(token);
    if (response && response.statusCode === 200) {
      setItemList(response?.data?.product);
    } else {
      errorMsg(response.message);
    }
  };

  const getFilteredOptions = (currentIndex) => {
    const selectedIds = applyForm.product_details
      .filter((_, idx) => idx !== currentIndex)
      .map((pd) => pd.product_id);

    return itemList
      .filter((item) => !selectedIds.includes(item.id))
      .map((item) => ({
        value: item.id,
        label: `${item.name} (Max Qty: ${item.max_quantity_ordered})`,
      }));
  };

  const setData = (e, key, field, index) => {
    let data = applyForm[key] ?? [];
    data[index] = { ...data[index], [field]: e };
    setApplyForm({
      ...applyForm,
      [key]: data,
    });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const setNormalData = (e, key) => {
    setApplyForm({ ...applyForm, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const setAddArrayData = (key, index) => {
    let data = applyForm[key];
    data.push({ id: index + 1 });
    setApplyForm({
      ...applyForm,
      [key]: data,
    });
  };

  const setRemoveArrayData = (key, id) => {
    let data = [...applyForm[key]];
    data = data.filter((_, index) => _.id !== id);
    setApplyForm({
      ...applyForm,
      [key]: data,
    });
  };

  const removeIdFromInstances = (data) => {
    const updatedData = {};
    for (const key in data) {
      if (Array.isArray(data[key])) {
        updatedData[key] = data[key].map((item) => {
          const { id, error, ...rest } = item;
          return rest;
        });
      } else {
        updatedData[key] = data[key];
      }
    }
    return updatedData;
  };

  const checkStatus = (data) => {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const innerData = data[key];
        for (const innerKey in innerData) {
          if (Object.hasOwnProperty.call(innerData, innerKey)) {
            const nestedObject = innerData[innerKey];
            for (const nestedKey in nestedObject) {
              if (Object.hasOwnProperty.call(nestedObject, nestedKey)) {
                if (!nestedObject[nestedKey].status) {
                  return false;
                }
              }
            }
          }
        }
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedIds = applyForm.product_details.map((p) => p.product_id);
    const hasDuplicates = new Set(selectedIds).size !== selectedIds.length;
    if (hasDuplicates) {
      errorMsg("Same item cannot be selected more than once.");
      return;
    }

    let validate = {
      product_details: {},
    };
    validate.employee_name = NonEmptyValidation(applyForm?.employee_name);
    validate.department_id = NonEmptyValidation(applyForm?.department_id);
    if (applyForm?.product_details) {
      applyForm?.product_details?.forEach((report) => {
        const valide = {
          product_id: NonEmptyValidation(report?.product_id),
          quantity: NumberValidation(report?.quantity),
        };
        validate.product_details = {
          ...validate.product_details,
          [report.id.toString()]: valide,
        };
      });
    }

    setValidation(validate);

    if (checkStatus(validate)) {
      const Payload = {
        ...applyForm,
      };
      const modifiedData = removeIdFromInstances(Payload);
      const response = await CreateIndentForm(modifiedData, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        navigate(-1);
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };

  const handleQuantityChange = (newValue, key, field, index) => {
    const selectedItem = itemList.find(
      (item) => item.id === applyForm[key][index].product_id
    );
    const maxQty = selectedItem ? selectedItem.max_quantity_ordered : 0;

    setApplyForm((prevData) => {
      const newData = [...prevData[key]];
      const numericValue = parseFloat(newValue);

      if (isNaN(numericValue)) {
        newData[index] = {
          ...newData[index],
          [field]: newValue,
          error: "Invalid input: Only valid number.",
        };
      } else {
        newData[index] = {
          ...newData[index],
          [field]: numericValue,
          error:
            numericValue > maxQty
              ? "Quantity cannot be greater than Max Quantity"
              : null,
        };
      }
      return {
        ...prevData,
        [key]: newData,
      };
    });
  };

  return (
    <div className="">
      <section className="top-content-container">
        <div className="my-4">
          <div className="row">
            <div className="col-lg-6 p-0">
              <h6 className="headertext">{first_name + " " + last_name}</h6>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="row">
          <div className="">
            <div className="graphbox">
              <h6 className="labeltitle">
                <span className="arrowicon" onClick={() => navigate(-1)}>
                  ← &nbsp;
                </span>
                Back To Indent List
              </h6>
              <div className="mt-5">
                <h5 className="centertext">
                  INDENT FORM FOR STATIONERIES AND OTHER CONSUMABLE ITEMS TO BE ISSUED BY STORES
                </h5>
              </div>
              <form>
                <div className="row mt-5">
                  <div className="col-lg-6">
                    <label className="labeltext">Name of the Indentor *</label>
                    <input
                      type="text"
                      className="fieldinput"
                      placeholder="Enter Indentor Name"
                      defaultValue={applyForm?.employee_name}
                      onChange={(e) => setNormalData(e.target.value, "employee_name")}
                    />
                    <small className="validationerror">
                      {validation?.employee_name?.message ? `Indentor Name ${validation?.employee_name?.message}` : ""}
                    </small>
                  </div>
                  <div className="col-lg-6">
                    <label className="labeltext">Name of the Department *</label>
                    <select
                      className="fieldinput"
                      defaultValue={applyForm?.department_id}
                      onChange={(e) => setNormalData(e.target.value, "department_id")}
                    >
                      <option value="">Select Department</option>
                      {departmentt?.map((e, index) => (
                        <option key={index} value={e.id}>
                          {e.name}
                        </option>
                      ))}
                    </select>
                    <small className="validationerror">
                      {validation?.department_id?.message ? `Department ${validation?.department_id?.message}` : ""}
                    </small>
                  </div>
                </div>
                <div className="my-5">
                  <h6> Requirements</h6>
                </div>
                <div className="my-5">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name of the Item</th>
                        <th>Available In Store</th>
                        <th>Quantity Required</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {applyForm?.product_details?.map((report, index) => (
                        <tr key={report.id}>
                          <td>{index + 1}</td>
                          <td>
                            <ReactSelect
                              value={getFilteredOptions(index).find(
                                (option) => option.value === report.product_id
                              )}
                              onChange={(selectedOption) =>
                                setData(selectedOption?.value || "", "product_details", "product_id", index)
                              }
                              options={getFilteredOptions(index)}
                              isSearchable
                              placeholder="Select Item"
                            />
                            <small className="validationerror">
                              {validation?.product_details?.[report.id.toString()]?.product_id?.message
                                ? `Item ${validation?.product_details?.[report.id.toString()]?.product_id?.message}`
                                : ""}
                            </small>
                          </td>
                          <td>
                            {report.product_id
                              ? itemList.find((item) => item.id === report.product_id)?.quantity || ""
                              : "-"}
                          </td>
                          <td>
                            <input
                              type="text"
                              className="fieldinputreport"
                              placeholder="Enter Quantity Report"
                              value={report?.quantity || ""}
                              onChange={(e) =>
                                handleQuantityChange(e.target.value, "product_details", "quantity", index)
                              }
                            />
                            {report?.error && <small className="validationerror">{report?.error}</small>}
                            <small className="validationerror">
                              {validation?.product_details?.[report.id.toString()]?.quantity?.message
                                ? `Quantity ${validation?.product_details?.[report.id.toString()]?.quantity?.message}`
                                : ""}
                            </small>
                          </td>
                          <td>
                            {applyForm.product_details.length - 1 === index && (
                              <span
                                className="material-symbols-outlined addoption"
                                type="button"
                                onClick={() => setAddArrayData("product_details", index)}
                              >
                                add
                              </span>
                            )}
                            {applyForm.product_details.length !== 1 && (
                              <span
                                className="material-symbols-outlined removeoption"
                                type="button"
                                onClick={() => setRemoveArrayData("product_details", index)}
                              >
                                remove
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col-lg-3 centertext ms-auto mx-auto">
                    <div className="approvebutton" onClick={(e) => handleSubmit(e)}>
                      Submit
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndentForm;
